var _line, _line2, _line3, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlendsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x2: 2.4,
    y2: 3.2,
    transform: "translate(5.8 6.4)",
    stroke: "#eef8ff",
    strokeWidth: 2,
    fill: "none",
    strokeMiterlimit: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 3.2,
    x2: 2.4,
    transform: "translate(5.8 14.4)",
    stroke: "#eef8ff",
    strokeWidth: 2,
    fill: "none",
    strokeMiterlimit: 10
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x2: 4,
    transform: "translate(13 12)",
    stroke: "#eef8ff",
    strokeWidth: 2,
    fill: "none",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1 1)",
    stroke: "#eef8ff",
    strokeWidth: 2,
    fill: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(1 17)",
    stroke: "#eef8ff",
    strokeWidth: 2,
    fill: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(17 9)",
    stroke: "#eef8ff",
    strokeWidth: 2,
    fill: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(7 9)",
    stroke: "#eef8ff",
    strokeWidth: 2,
    fill: "none",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlendsicon);
export default __webpack_public_path__ + "static/media/blendsicon.8a6be774b3ae85ae33f97b59ff6ad7f2.svg";
export { ForwardRef as ReactComponent };